// API Base Configuration
export const API_CONFIG = {
  BASE_URL: 'https://rudraksh-api.volvrit.org/api/rudraksh',
  IMAGE_BASE_URL: 'https://rudraksh-api.volvrit.org',
  TIMEOUT: 10000,
};

// API Endpoints
export const API_ENDPOINTS = {
  // Auth Endpoints
  AUTH: {
    LOGIN: '/user/login',
    LOGOUT: '/user/logout',
    PROFILE: '/auth/profile',
    CHANGE_PASSWORD: '/auth/changepassword',
    UPDATE_PROFILE: '/auth/update/profile',
    GET_CONTACT: '/auth/getcontact',
  },

  // User Endpoints
  USER: {
    GET_ALL: '/user/getall',
    GET_BY_ID: '/user',
    DELETE: '/user/delete',
    REGISTER: '/user/register',
    LOGIN: '/user/login',
    UPDATE_PROFILE: '/user/update/profile',
    GET_PROFILE: '/user/get/profile',
    FORGOT_PASSWORD: '/user/forgotpassword',
    RESET_PASSWORD: '/user/resetpassword',
  },

  // Product Endpoints
  PRODUCT: {
    GET_ALL: '/product/get-all',
    CREATE: '/product/create',
    UPDATE: '/product/update',
    DELETE: '/product/delete',
    GET_BY_ID: '/product',
  },

  // Category Endpoints
  CATEGORY: {
    GET_ALL: '/category/getall',
    CREATE: '/category/create',
    UPDATE: '/category/update',
    DELETE: '/category/delete',
    GET_BY_ID: '/category',
  },

  // Blog Endpoints
  BLOG: {
    GET_ALL: '/blogs/get-all',
    CREATE: '/blogs/create',
    UPDATE: '/blogs/update',
    DELETE: '/blogs/delete',
    GET_BY_ID: '/blogs/get-details',
    ADD_MESSAGE: '/blogs/add-message',
  },

  // Order Endpoints
  ORDER: {
    GET_ALL: '/order/get-all-order',
    GET_BY_ID: '/order/get-details',
    UPDATE: '/order/update-status',
    DELETE: '/order/delete',
  },

  // Banner Endpoints
  BANNER: {
    GET_ALL: '/banner/getall',
    CREATE: '/banner/insert',
    UPDATE: '/banner/update',
    DELETE: '/banner/delete',
    GET_BY_ID: '/banner/getbyid',
  },

  // FAQ Endpoints
  FAQ: {
    GET_ALL: '/faq/getall',
    CREATE: '/faq/add',
    UPDATE: '/faq/update',
    DELETE: '/faq/delete',
  },

  // Terms & Conditions Endpoints
  TERMS: {
    GET_ALL: '/termsandconditions/getall',
    CREATE: '/termsandconditions/add',
    UPDATE: '/termsandconditions/update',
    DELETE: '/termsandconditions/delete',
  },

  // Contact Form Endpoints
  CONTACT: {
    GET_ALL: '/contactform/getall',
    DELETE: '/contactform/delete',
  },

  // Coupon Endpoints
  COUPON: {
    GET_ALL: '/coupon/get-all',
    CREATE: '/coupon/create',
    UPDATE: '/coupon/update',
    DELETE: '/coupon/delete',
  },
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  SERVER_ERROR: 'Server error. Please try again later.',
  VALIDATION_ERROR: 'Please check your input and try again.',
  NOT_FOUND: 'Requested resource not found.',
  GENERIC_ERROR: 'Something went wrong. Please try again.',
};

// Success Messages
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Login successful',
  LOGOUT_SUCCESS: 'Logout successful',
  CREATE_SUCCESS: 'Created successfully',
  UPDATE_SUCCESS: 'Updated successfully',
  DELETE_SUCCESS: 'Deleted successfully',
  UPLOAD_SUCCESS: 'Upload successful',
};

// Request Headers
export const REQUEST_HEADERS = {
  JSON: {
    'Content-Type': 'application/json',
  },
  MULTIPART: {
    'Content-Type': 'multipart/form-data',
  },
  AUTH: (token: string) => ({
    'Authorization': `Bearer ${token}`,
  }),
  JSON_WITH_AUTH: (token: string) => ({
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`,
  }),
  MULTIPART_WITH_AUTH: (token: string) => ({
    'Content-Type': 'multipart/form-data',
    'Authorization': `Bearer ${token}`,
  }),
};

// Pagination Defaults
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_LIMIT: 10,
  MAX_LIMIT: 100,
};

// File Upload Limits
export const FILE_UPLOAD = {
  MAX_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_TYPES: ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'],
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.webp'],
};

// Utility Functions
export const getImageUrl = (imagePath: string | null | undefined): string => {
  if (!imagePath) return '/placeholder.jpg';
  
  // If already full URL, return as is
  if (imagePath.startsWith('http')) return imagePath;
  
  // Clean path - remove 'uploads/' prefix if present
  const cleanPath = imagePath.replace(/^uploads\//, '');
  
  return `${API_CONFIG.IMAGE_BASE_URL}/uploads/${cleanPath}`;
};
